'use strict';

import {post} from './xmlHttpWrapper';

function performWithPrefix(prefix: string) {
    return (proc_name: string, params: Array<any> = []) => {
        return post(prefix + proc_name, {params: params}).then((result) => {
            const name_parts = proc_name.split('.');
            return result.data[0][name_parts[name_parts.length - 1]];
        });
    };
}

type valueType = string|number|Date|boolean|Array<any>|{[key: string]: string}; // Note: Crazytown. This should be changed once some of the legacy code is cleaned up
type columnsList = Array<string>;
type columnKeyValue = {
    [column: string]: valueType
};
type whereClause = columnKeyValue;
type insertFields = columnKeyValue;
type updateFields = columnKeyValue;
type selectParams = {
    columns?: columnsList
    where?: whereClause
};

export class Ferry {
    static select<T>(table: string, columns: columnsList = undefined, where: whereClause = undefined): Promise<Array<T>> {
        const params: selectParams = {};
        if (columns) {
            params.columns = columns;
        }
        if (where) {
            params.where = where;
        }
        return post("/db/select/" + table, params).then((result) => result.data);
    }

    static selectone<T>(table: string, columns: columnsList = undefined, where: whereClause = undefined): Promise<T> {
        return this.select<T>(table, columns, where).then((rows) => rows[0]);
    }

    static sessionless_select<T>(table: string): Promise<Array<T>> {
        return post("/db/null/select/" + table).then((result) => result.data);
    }

    static perform<T>(proc_name: string, params: Array<valueType> = []): Promise<T> {
        return performWithPrefix("/db/perform/")(proc_name, params);
    }

    static sessionless_perform<T>(proc_name: string, params: Array<valueType>): Promise<T> {
        return performWithPrefix("/db/null/perform/")(proc_name, params);
    }

    static performset<T>(proc_name: string, params: Array<valueType>): Promise<Array<T>> {
        return post("/db/perform/" + proc_name, {params: params}).then((result) => result.data);
    }

    static sessionless_performset<T>(proc_name: string, params: Array<valueType>): Promise<Array<T>> {
        return post("/db/null/perform/" + proc_name, {params: params}).then((result) => result.data);
    }

    static insert(table: string, fields: insertFields): Promise<void> {
        return post("/db/insert/" + table, { fields }).then(() => null);
    }

    static update(table: string, fields: updateFields, where: whereClause): Promise<void> {
        return post("/db/update/" + table, { fields, where }).then(() => null);
    }

    static upsert(table: string, fields: updateFields, where: whereClause): Promise<void> {
        return post("/db/upsert/" + table, {fields: fields, where: where}).then(() => null);
    }

    static del(table: string, where: whereClause): Promise<void> {
        return post("/db/delete/" + table, { where }).then(() => null);
    }

    static call(url: string, params = {}) {
        return post(url, params).then((result) => result.data);
    }
}

export const ferry = Ferry;



// WEBPACK FOOTER //
// ./_src/services/ferry/ferry.ts